import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { LeadForm } from './LeadForm'
import { ActionsType } from './types'

const formName = 'add-edit-lead-form'

type Props = { lead?: ActionsType['lead'] } & Omit<ActionsType, 'lead'>

export const AddEditLead = ({ lead, ...props }: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      width={800}
      maskClosable={false}
      title={t('lead.contacts')}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      destroyOnHidden
      okButtonProps={{
        htmlType: 'submit',
        form: formName
      }}
      {...props}
    >
      <LeadForm id={lead?.id} formName={formName} closeModal={props.onCancel} />
    </Modal>
  )
}
